<template>
  <div class="title-bar">
    <ContextMenu
      id="user-mobile-menu"
      :items="menu"
      class="d-sm-none float-right"
      align="right"
    />
    <div class="row pl-3 justify-content-between">
      <h1>{{ title }}</h1>
    </div>
    <h4 class="text-primary mb-3">{{ user.name }} ({{ userId }})</h4>
    <a class="btn-back" :href="route('training.users.index')">
      <span class="icon icon-arrow-left"></span>
      <span class="text">Back to Users List</span>
    </a>
    <TabMenu
      :tabs="menu"
      :current="current"
      class="d-none d-sm-block pt-2"
      id="user-menu"
    />
  </div>
</template>
<script>
export default {
  props: {
    user: { type: Object, required: true },
    title: { type: String, required: true },
    current: { type: String, default: "" },
  },
  computed: {
    menu() {
      return [
        {
          label: "Details",
          action: () => {
            this.goToRoute("training.users.show", {
              user: this.user.id,
            });
          },
        },
        {
          label: "Hours",
          action: () => {
            this.showHoursModal();
          },
        },
        {
          label: "Training",
          action: () => {
            this.goToRoute("training.users.history.index", {
              type: "online",
              user: this.user.id,
            });
          },
        },
        {
          label: "Wishlist",
          action: () => {
            this.goToRoute("training.users.wishlist", {
              user: this.user.id,
            });
          },
        }
      ];
    },
    userId() {
      if (!!this.user.hvac_id) {
        return `HVAC ID: ${this.user.hvac_id}`;
      } else if (!!this.user.aviator_id) {
        return `Aviator ID: ${this.user.aviator_id}`;
      } else {
        return `MLC ID: ${this.user.id}`;
      }
    },
  },
  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { user: this.user })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "sass/variables";

#user-menu {
  border-top: 2px solid $gray-300;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: 1rem;
  padding-left: 1.5rem;
}
</style>